/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
/* eslint-disable prefer-destructuring */
/* eslint-disable arrow-body-style */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { TextField, Switch, FormControlLabel, Checkbox, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Formik, Form, FieldArray } from 'formik';
import * as Yup from 'yup';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { LoadingButton } from '@mui/lab';

import Page from '../../../components/Page';
import subscriptionServices from '../../../services/subscriptionServices';
import adminServices from '../../../services/adminServices';
import ErrorFocus from '../../../components/ErrorFocus/ErrorFocus';
import SnackBar from '../../../components/snackbar/snackbar';
import { ASSESSMENT_TYPES } from './components/shared/inputSx';
import { SectionCard, FieldLabel, TierButton, ScopeCard, AssessmentTypeCard, FeatureBullets, BackLink, PageHeading, SearchBox } from './components/shared/SharedComponents';

const BillingToggle = ({ value, onChange }) => (
  <div className="flex border border-gray-200 rounded-[7px] overflow-hidden">
    {['Monthly', 'Yearly'].map((opt) => (
      <button
        key={opt}
        type="button"
        onClick={() => onChange(opt)}
        className="flex-1 text-center px-4 py-[9px] text-[13px] font-medium cursor-pointer select-none transition-all"
        style={{
          background: value === opt ? '#eff6ff' : '#fff',
          color: value === opt ? '#1d4ed8' : '#374151',
          border: value === opt ? '1.5px solid #2563eb' : '1px solid transparent',
          borderRadius: value === opt ? '6px' : 0,
        }}
      >
        {opt}
      </button>
    ))}
  </div>
);

const TierWatcher = ({ tier, setFieldValue }) => {
  React.useEffect(() => {
    if (tier === 'BASIC') {
      setFieldValue('assessmentTypes', ['FULL_TEST']);
    } else if (tier === 'PRO') {
      setFieldValue('assessmentTypes', ['FULL_TEST', 'SUBJECT_TEST']);
    } else if (tier === 'PREMIUM') {
      setFieldValue('assessmentTypes', ['FULL_TEST', 'SUBJECT_TEST', 'CHAPTER_TEST']);
    }
    else {
      setFieldValue('assessmentTypes', ['FULL_TEST', 'SUBJECT_TEST', 'CHAPTER_TEST']);
    }
  }, [tier]);
  return null;
};

const CreateAssessmentPlan = () => {
  const navigate = useNavigate();
  const [assessmentList, setAssessmentList] = useState([]);
  const [assessmentSearch, setAssessmentSearch] = useState('');
  const [assessmentsLoading, setAssessmentsLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, title: '' });
  const [submittingDraft, setSubmittingDraft] = useState(false);
  const [submittingPublish, setSubmittingPublish] = useState(false);
  const publishModeRef = React.useRef('draft');
  const [planDetails, setPlanDetails] = useState([]);
  const [lookups, setLookups] = useState({ subscription_ids: [], currency_type: [], assessment_exam_categories: [] });


  useEffect(() => {
    fetchAssessments();
    fetchLookups();
    getAssessmentPlanDetails();
  }, []
  );

  const getAssessmentPlanDetails = async () => {
    const plandetails = await subscriptionServices.getAssessmentplandetails()
    setPlanDetails(plandetails.data)
  }
  const fetchLookups = async () => {
    try {
      const res = await adminServices.getLookUpData('subscription_ids,currency_type,assessment_exam_categories');
      console.log('lookup result:', res.ok, res.data);
      if (res.ok) setLookups(prev => ({ ...prev, ...(res.data || {}) }));
    } catch (e) { console.error('[CreateAssessmentPlan lookups]', e); }
  };

  const fetchAssessments = async () => {
    setAssessmentsLoading(true);
    try {
      const res = await adminServices.getGenericAssessmentDropDown();
      if (res.ok) {
        const filtered = res.data.filter((item) => item?.status_type === 1);
        setAssessmentList(filtered|| []);
      }
    } catch (e) { console.error('[CreateAssessmentPlan]', e); }
    setAssessmentsLoading(false);
  };


  const initialValues = {
    planName: '', displayName: '', tagline: '', billingtype: 'recurring', tier: 'BASIC', mostPopular: false, enableonline: false,
    ctaLabel: '', scope: 'platform', price: '', billingCycle: 'Monthly',
    assessmentTypes: [], maxAttempts: 5, featureBullets: ['', '', ''], priceUSD: '',
    footnote: '', selectedAssessments: [], categoryId: '', description: '',
  };

  const validationSchema = Yup.object().shape({
    planName: Yup.string().trim().min(3, 'Minimum 3 characters').required('Required'),
    // price: Yup.number().min(0, 'Enter 0 for free').required('Required'),
    // priceUSD: Yup.number().min(0, 'Enter 0 for free').required('Required'),
    price: Yup.number().when('tier', {
      is: (tier) => tier !== 'FREE',
      then: (schema) =>
        schema
          .min(0, 'Enter 0 for free')
          .required('Required'),
      otherwise: (schema) => schema.notRequired(),
    }),

    priceUSD: Yup.number().when('tier', {
      is: (tier) => tier !== 'FREE',
      then: (schema) =>
        schema
          .min(0, 'Enter 0 for free')
          .required('Required'),
      otherwise: (schema) => schema.notRequired(),
    }),

    assessmentTypes: Yup.array().min(1, 'Select at least one assessment type'),
  });


  const validatePlan = (values, planDetails) => {
    const exists = planDetails.some(plan => {
      if (values.scope === 'platform') {
        if (values.tier === 'FREE') return false;
        return plan.scope === 'platform' &&
          plan.tier === values.tier;
      }

      if (values.scope === 'category') {
        return plan.scope === 'category' &&
          plan.tier === values.tier &&
          plan.type === values.categoryId;
      }

      return false;
    });

    if (!exists) return null;

    return values.scope === 'category'
      ? `Plan already exists for ${values.categoryId} category with ${values.tier} tier`
      : `Plan already exists for platform scope with ${values.tier} tier`;
  };

  const handleSubmit = async (values, publishMode = 'draft') => {
    console.log(values, "valuesvalues");
    const planexist = validatePlan(values, planDetails)
    console.log(planexist, "planexistplanexist");

    if (planexist !== null) {
      setSnackbar({ open: true, title: planexist });
    } else {
      if (submittingDraft || submittingPublish) return;
      if (publishMode === 'draft') setSubmittingDraft(true);
      else setSubmittingPublish(true);
      try {
        const fd = new FormData();
        if (publishMode === 'publish' && !values.enableonline) {
          setSnackbar({
            open: true,
            title: 'Please enable online before publishing.',
          });
          setSubmittingPublish(false)
          return false;
        }



        fd.append('name', values.planName);
        fd.append('shortDescription', JSON.stringify([values.displayName || '']));
        fd.append('tagline', values.tagline || '');
        fd.append('description', values.description || '');
        fd.append('is_popular', String(values.mostPopular));
        fd.append('is_active', String(values.enableonline));
        fd.append('cta_label', values.ctaLabel || '');
        fd.append('planType', 'assessment');
        fd.append('scope', values.scope);
        fd.append('tier', values.tier);
        fd.append('billingtype', values.billingtype);
        fd.append('subscriptionPlan', values.billingCycle === 'Yearly' ? 'Online Yearly' : 'Online Monthly - Bundle');
        fd.append('subscriptionType', 'B2C');
        fd.append('isOnline', publishMode === 'publish' ? 'true' : 'false');
        fd.append('isPaid', Number(values.price) > 0 ? 'true' : 'false');
        fd.append('frequency', values.billingCycle === 'Yearly' ? '1' : '2');
        fd.append('discountPercentage', '0');

        const currencies = (lookups.currency_type || []).length > 0
          ? lookups.currency_type
          : [{ code: 'INR' }, { code: 'USD' }];
        fd.append('prices', JSON.stringify(
          currencies.map(c => ({
            currencyType: c.code,
            actualCost: c.code === 'INR' ? Number(values.price) || 0 : Number(values.priceUSD) || 0,
          }))
        ));
        const finalAssessmentTypes =
          values.assessmentTypes.length > 0
            ? values.assessmentTypes
            : (values.tier === 'BASIC'
              ? ['FULL_TEST']
              : ['FULL_TEST', 'SUBJECT_TEST', 'CHAPTER_TEST']);

        fd.append('assessment_types', JSON.stringify(finalAssessmentTypes));
        fd.append('plan_category', 'ASSESSMENT');
        fd.append('max_attempts_per_assessment', String(values.maxAttempts));
        fd.append('assessmentIds', JSON.stringify(values.selectedAssessments));
        fd.append('courseIds', JSON.stringify([]));
        fd.append('feature_bullets', JSON.stringify(values.featureBullets.filter(Boolean)));
        fd.append('footnote', values.footnote || '');


        if (values.scope === 'category' && values.categoryId) {
          fd.append('categoryId', values.categoryId);
        }

        const subIds = lookups.subscription_ids || [];
        const subName = values.billingCycle === 'Yearly' ? 'Online Yearly' : 'Online Monthly - Bundle';
        const subId = subIds.find(s => s.name === subName)?.id;
        if (!subId) {
          setSnackbar({ open: true, title: `Subscription record "${subName}" not found. Contact admin.` });
          if (publishMode === 'draft') setSubmittingDraft(false); else setSubmittingPublish(false);
          return;
        }
        const res = await subscriptionServices.postSubscriptionPlan(subId, fd, 'assessment');
        if (res.ok) {
          setSnackbar({ open: true, title: publishMode === 'publish' ? 'Plan published!' : 'Draft saved' });
          setTimeout(() => navigate('/app/subscription?tab=0'), 1200);
        } else {
          setSnackbar({ open: true, title: res.data?.message || 'Something went wrong' });
        }
      } catch (e) {
        console.error('[CreateAssessmentPlan]', e);
        setSnackbar({ open: true, title: 'Something went wrong' });
      }
      if (publishMode === 'draft') setSubmittingDraft(false);
      else setSubmittingPublish(false);
    }
  };

  const renderAssessmentList = (values, setFieldValue) => {
    const filtered = assessmentList.filter((a) => {
      const searchLower = assessmentSearch.toLowerCase();

      const matchesSearch =
        (a.title || '').toLowerCase().includes(searchLower) ||
        (a.type || '').toLowerCase().includes(searchLower) ||
        (a.assessment_sub_type_description || '')
          .toLowerCase()
          .includes(searchLower);

      const audienceOk =
        a.audience === 'B2C' || a.audience === 'BOTH';

      const examType = (
        a.type ||
        a.assessment_type_code ||
        ''
      ).toUpperCase();

      const categoryOk =
        values.scope !== 'category' ||
        !values.categoryId ||
        examType === values.categoryId.toUpperCase();

      const subTypeDesc = (
        a.assessment_sub_type_description || ''
      ).toUpperCase();

      const isFullTest = subTypeDesc === 'FULL TEST';
      const isSubject = subTypeDesc === 'SUBJECT TEST';
      const isChapter = subTypeDesc.includes('CHAPTER TEST');

      const tierOk = !values.tier
        ? true
        : values.tier === 'BASIC'
          ? isFullTest
          : values.tier === 'PRO'
            ? isFullTest || isSubject
            : values.tier === 'PREMIUM'
              ? isFullTest || isSubject || isChapter
              : true;

      return (
        matchesSearch &&
        audienceOk &&
        categoryOk &&
        tierOk
      );
    });

    if (assessmentsLoading) {
      return (
        <div className="flex justify-center py-8">
          <CircularProgress
            size={20}
            sx={{ color: '#2563eb' }}
          />
        </div>
      );
    }

    if (filtered.length === 0) {
      return (
        <div className="flex justify-center py-8">
          <p className="text-[13px] text-gray-400">
            No assessments available
          </p>
        </div>
      );
    }

    return filtered.map((a, idx) => {
      const id = a.id;

      const title =
        a.title || `Assessment ${idx + 1}`;

      const examCategory =
        a.type || a.assessment_type_code || '';

      const subType =
        a.assessment_sub_type_description ||
        'Full Test';

      const type =
        examCategory && subType
          ? `${examCategory} · ${subType}`
          : examCategory || subType || 'Full Test';

      const checked =
        values.selectedAssessments.includes(id);

      return (
        <div
          key={id}
          className="flex items-center px-[14px] py-[10px] hover:bg-gray-50"
          style={{
            borderBottom:
              idx < filtered.length - 1
                ? '1px solid #f3f4f6'
                : 'none',
          }}
        >
          <Checkbox
            size="small"
            checked={checked}
            onChange={() => {
              if (checked) {
                setFieldValue(
                  'selectedAssessments',
                  values.selectedAssessments.filter(
                    (i) => i !== id
                  )
                );
              } else {
                setFieldValue(
                  'selectedAssessments',
                  [
                    ...values.selectedAssessments,
                    id,
                  ]
                );
              }
            }}
            sx={{
              p: '4px',
              mr: '10px',
              color: '#d1d5db',
              '&.Mui-checked': {
                color: '#2563eb',
              },
            }}
          />

          <div>
            <p className="text-[13px] font-medium text-gray-900">
              {title}
            </p>

            <p className="text-[11px] text-gray-400 uppercase tracking-[0.04em]">
              {type}
            </p>
          </div>
        </div>
      );
    });
  };
  // const renderAssessmentList = (values, setFieldValue) => {

  //   const filtered = assessmentList.filter((a) => {
  //     const searchLower = assessmentSearch.toLowerCase();
  //     const matchesSearch =
  //       (a.title || '').toLowerCase().includes(searchLower) ||
  //       (a.type || '').toLowerCase().includes(searchLower) ||
  //       (a.assessment_sub_type_description || '').toLowerCase().includes(searchLower);

  //     const audienceOk = a.audience === 'B2C' || a.audience === 'BOTH';

  //     const examType = (a.type || a.assessment_type_code || '').toUpperCase();
  //     const categoryOk = values.scope !== 'category' || !values.categoryId ||
  //       examType === values.categoryId.toUpperCase();

  //     const subTypeDesc = (a.assessment_sub_type_description || '').toUpperCase();
  //     const isFullTest = subTypeDesc === 'FULL TEST';
  //     const isSubject = subTypeDesc === 'SUBJECT TEST';
  //     const isChapter = subTypeDesc.includes('CHAPTER TEST');

  //     const tierOk = !values.tier ? true
  //       : values.tier === 'BASIC' ? isFullTest
  //         : values.tier === 'PRO' ? isFullTest || isSubject
  //           : values.tier === 'PREMIUM' ? isFullTest || isSubject || isChapter
  //             : true;
  //     return matchesSearch && audienceOk && categoryOk && tierOk;
  //   });

  //   const filteredIds = filtered.map((a) => a.id);
  //   const cleanedSelected = values.selectedAssessments.filter((id) => filteredIds.includes(id));
  //   if (cleanedSelected.length !== values.selectedAssessments.length) {
  //     setFieldValue('selectedAssessments', cleanedSelected);
  //   }

  //   if (assessmentsLoading) {
  //     return (
  //       <div className="flex justify-center py-8">
  //         <CircularProgress size={20} sx={{ color: '#2563eb' }} />
  //       </div>
  //     );
  //   }
  //   if (filtered.length === 0) {
  //     return (
  //       <div className="flex justify-center py-8">
  //         <p className="text-[13px] text-gray-400">No assessments available</p>
  //       </div>
  //     );
  //   }
  //   return filtered.map((a, idx) => {
  //     const id = a.id;
  //     const title = a.title || `Assessment ${idx + 1}`;
  //     const examCategory = a.type || a.assessment_type_code || '';
  //     const subType = a.assessment_sub_type_description || 'Full Test';
  //     const type = examCategory && subType ? `${examCategory} · ${subType}` : examCategory || subType || 'Full Test';
  //     const checked = values.selectedAssessments.includes(id);
  //     return (
  //       <div
  //         key={id}
  //         className="flex items-center px-[14px] py-[10px] hover:bg-gray-50"
  //         style={{ borderBottom: idx < filtered.length - 1 ? '1px solid #f3f4f6' : 'none' }}
  //       >
  //         <Checkbox
  //           size="small"
  //           checked={checked}
  //           onChange={() =>
  //             setFieldValue(
  //               'selectedAssessments',
  //               checked
  //                 ? values.selectedAssessments.filter((i) => i !== id)
  //                 : [...values.selectedAssessments, id]
  //             )
  //           }
  //           sx={{ p: '4px', mr: '10px', color: '#d1d5db', '&.Mui-checked': { color: '#2563eb' } }}
  //         />
  //         <div>
  //           <p className="text-[13px] font-medium text-gray-900">{title}</p>
  //           <p className="text-[11px] text-gray-400 uppercase tracking-[0.04em]">{type}</p>
  //         </div>
  //       </div>
  //     );
  //   });
  // };

  return (
    <Page title="">
      <div className="max-w-[720px] mx-auto px-4 md:px-8 py-6">
        <BackLink label="Back to Plans" onClick={() => navigate('/app/subscription')} />
        <PageHeading title="Create Assessment Plan" subtitle="Define the plan identity, scope, pricing, and access rules." />

        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={(v) => handleSubmit(v, publishModeRef.current)}>
          {({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => {

            return (
              <>
                <TierWatcher tier={values.tier} setFieldValue={setFieldValue} />
                <Form>
                  <ErrorFocus />

                  {/* 1 — Plan Identity */}
                  <SectionCard step={1} title="Plan Identity" subtitle="Internal name, customer-facing name, and marketing copy.">
                    <div className="flex flex-col gap-[18px]">
                      <div>
                        <FieldLabel required>Plan name (internal)</FieldLabel>
                        <TextField fullWidth name="planName" placeholder="e.g. All Exams Pro" value={values.planName} onChange={handleChange} onBlur={handleBlur} error={Boolean(touched.planName && errors.planName)} helperText={touched.planName && errors.planName} size="small" />
                      </div>
                      <div>
                        <FieldLabel>Display name (customer-facing)</FieldLabel>
                        <TextField fullWidth name="displayName" placeholder="e.g. Pro Plan" value={values.displayName} onChange={handleChange} onBlur={handleBlur} size="small" />
                        <p className="text-[11px] text-gray-400 mt-1">Shown on pricing page. Defaults to plan name if blank.</p>
                      </div>
                      <div>
                        <FieldLabel>Tagline</FieldLabel>
                        <TextField fullWidth name="tagline" placeholder="e.g. Everything you need to crack the exam" value={values.tagline} onChange={handleChange} onBlur={handleBlur} size="small" />
                      </div>
                      <div>
                        <FieldLabel>Description</FieldLabel>
                        <TextField fullWidth multiline rows={3} name="description" placeholder="e.g. Full access to all exams with detailed analytics" value={values.description} onChange={handleChange} onBlur={handleBlur} size="small" />
                      </div>

                      <div>
                        <FieldLabel required>Tier</FieldLabel>
                        <div className="flex gap-[10px]">
                          {['BASIC', 'PRO', 'PREMIUM', 'FREE'].map((t) => (
                            <TierButton key={t} label={t} selected={values.tier === t} onClick={() => setFieldValue('tier', t)} />
                          ))}
                        </div>
                      </div>
                      <FormControlLabel
                        control={<Switch checked={values.mostPopular} onChange={(e) => setFieldValue('mostPopular', e.target.checked)} size="small" sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#2563eb' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { background: '#2563eb' } }} />}
                        label={<span className="text-[13px] text-gray-700">Mark as &ldquo;Most Popular&rdquo;</span>}
                      />
                      <div>
                        <FieldLabel>CTA button label override</FieldLabel>
                        <TextField fullWidth name="ctaLabel" placeholder="Get Started (default)" value={values.ctaLabel} onChange={handleChange} onBlur={handleBlur} size="small" />
                      </div>


                      <div>
                        <FieldLabel>Enable Online</FieldLabel>
                        <FormControlLabel
                          control={<Switch checked={values.enableonline} onChange={(e) => setFieldValue('enableonline', e.target.checked)} size="small" sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#2563eb' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { background: '#2563eb' } }} />}
                          label={<span className="text-[13px] text-gray-700">Mark as Active</span>}
                        />
                      </div>
                    </div>
                  </SectionCard>

                  {/* 2 — Plan Scope */}
                  <SectionCard step={2} title="Plan Scope" subtitle="Platform-wide covers all categories. Category Bundle is locked to one exam.">
                    <FieldLabel required>Plan scope</FieldLabel>
                    <div className="flex gap-3">
                      <ScopeCard title="Platform-wide" subtitle="All exam categories included" selected={values.scope === 'platform'}
                        onClick={() => { setFieldValue('scope', 'platform'); setFieldValue('categoryId', ''); }} />
                      <ScopeCard title="Category Bundle" subtitle="One exam category only" selected={values.scope === 'category'}
                        onClick={() => setFieldValue('scope', 'category')} />
                    </div>
                    {values.scope === 'category' && (
                      <div className="mt-4 w-full">
                        <FieldLabel required>Exam category</FieldLabel>
                        {(lookups.assessment_exam_categories || []).length === 0 ? (
                          <p className="text-xs text-gray-400">Loading categories...</p>
                        ) : (
                          <div className="flex flex-wrap gap-2 mt-1">
                            {(lookups.assessment_exam_categories || []).map((cat) => (
                              <button
                                key={cat.code}
                                type="button"
                                onClick={() => setFieldValue('categoryId', cat.code)}
                                className={`px-3 py-1.5 rounded-lg text-sm font-medium border transition-all duration-150
                ${values.categoryId === cat.code
                                    ? 'border-blue-600 bg-blue-50 text-blue-700'
                                    : 'border-gray-300 bg-white text-gray-700 hover:border-gray-400'
                                  }`}
                              >
                                {cat.code}
                              </button>
                            ))}
                          </div>
                        )}
                        <p className="text-xs text-gray-400 mt-1">
                          This plan will only show assessments from this exam category.
                        </p>
                      </div>
                    )}
                  </SectionCard>

                  {/* 3 — Pricing */}

                  {values?.tier !== "FREE" &&
                    <SectionCard step={3} title="Pricing" subtitle="Set the monthly price. Stripe Product is created on publish.">
                      <div className="flex gap-4">
                        <div className="flex-1">
                          <FieldLabel required>Price (₹/month)</FieldLabel>
                          <TextField fullWidth name="price" type="number" placeholder="299" value={values.price} onChange={handleChange} onBlur={handleBlur} error={Boolean(touched.price && errors.price)} helperText={touched.price && errors.price}
                            InputProps={{ startAdornment: <span className="text-gray-500 mr-1 text-[13px]">₹</span> }} size="small" />
                          <p className="text-[11px] text-gray-400 mt-1">Enter 0 for a free plan</p>
                        </div>
                        <div className="flex-1">
                          <FieldLabel required>Price (USD/month)</FieldLabel>
                          <TextField fullWidth name="priceUSD" type="number" placeholder="3.99"
                            value={values.priceUSD} onChange={handleChange} onBlur={handleBlur}
                            error={Boolean(touched.priceUSD && errors.priceUSD)}
                            helperText={touched.priceUSD && errors.priceUSD}
                            InputProps={{ startAdornment: <span className="text-gray-500 mr-1 text-[13px]">$</span> }}
                            size="small" />
                          <p className="text-[11px] text-gray-400 mt-1">Enter 0 for a free plan</p>
                        </div>
                        <div className="flex-1">
                          <FieldLabel>Billing cycle</FieldLabel>
                          <BillingToggle value={values.billingCycle} onChange={(v) => setFieldValue('billingCycle', v)} />
                        </div>

                      </div>
                      <div className="mt-4">
                        <FieldLabel required>Billing Type</FieldLabel>
                        <div className="flex gap-[10px]">
                          {['recurring', 'one_time'].map((t) => (
                            <TierButton
                              key={t}
                              label={t}
                              selected={values.billingtype === t}
                              onClick={() => setFieldValue('billingtype', t)}
                            />
                          ))}
                        </div>
                      </div>
                    </SectionCard>
                  }

                  {/* 4 — Access Rules */}
                  <SectionCard step={4} title="Access Rules" subtitle="Define allowed assessment types and attempt limits.">
                    <div className="mb-5">
                      <FieldLabel required>Allowed assessment types</FieldLabel>
                      {touched.assessmentTypes && errors.assessmentTypes && (
                        <p className="text-[11px] text-red-500 mb-[6px]">{errors.assessmentTypes}</p>
                      )}
                      <div className="flex gap-3">
                        {ASSESSMENT_TYPES.map((at) => {
                          const sel = values.assessmentTypes.includes(at.key);
                          const isLocked = (values.tier === 'BASIC' && at.key !== 'FULL_TEST') || (values.tier === 'PRO' && at.key === 'CHAPTER_TEST');
                          return (
                            <AssessmentTypeCard key={at.key} title={at.label} subtitle={at.subtitle}
                              selected={sel && !isLocked}
                              disabled={isLocked}
                              onClick={() => {
                                if (isLocked) return;
                                setFieldValue('assessmentTypes', sel ? values.assessmentTypes.filter((k) => k !== at.key) : [...values.assessmentTypes, at.key]);
                              }} />
                          );
                        })}
                      </div>
                    </div>
                    <div>
                      <FieldLabel>Max paid attempts per assessment</FieldLabel>
                      <div className="flex items-center gap-3">
                        <TextField name="maxAttempts" type="number" value={values.maxAttempts} onChange={handleChange} inputProps={{ min: 1, max: 100 }} sx={{ width: '100px' }} size="small" />
                        <div className="flex items-center gap-[5px] text-gray-500">
                          <InfoOutlinedIcon sx={{ fontSize: '15px' }} />
                          <p className="text-[12px]">Free attempt always included (1 per assessment, all tiers)</p>
                        </div>
                      </div>
                    </div>
                  </SectionCard>

                  {/* 5 — Feature Bullets */}
                  <SectionCard step={5} title="Feature Bullets & Footnote" subtitle="Marketing copy for the pricing card. Max 7 bullets, 80 chars each.">
                    <FieldLabel>Feature bullets</FieldLabel>
                    <FieldArray name="featureBullets">
                      {({ push, remove }) => <FeatureBullets values={values} handleChange={handleChange} push={push} remove={remove} />}
                    </FieldArray>
                    <div className="mt-2">
                      <FieldLabel>Footnote</FieldLabel>
                      <TextField fullWidth name="footnote" placeholder="e.g. Cancel anytime. No credit card required." value={values.footnote} onChange={handleChange} onBlur={handleBlur} size="small" />
                      <p className="text-[11px] text-gray-400 mt-1">Small print below the CTA button on the pricing card.</p>
                    </div>
                  </SectionCard>

                  {/* 6 — Assessments */}
                  <SectionCard step={6} title="Assessments" subtitle="Optionally add LIVE B2C assessments now. You can always add more from the plan detail page.">
                    <div className="mb-2">
                      <SearchBox value={assessmentSearch} onChange={(e) => setAssessmentSearch(e.target.value)} placeholder="Search assessments..." />
                    </div>
                    <div className="border border-gray-200 rounded-[7px] max-h-[240px] overflow-y-auto">
                      {renderAssessmentList(values, setFieldValue)}
                    </div>
                    {values.selectedAssessments.filter((id) => assessmentList.some((a) => a.id === id)
                    ).length > 0 && (
                        <p className="text-[12px] text-gray-500 mt-2">{values.selectedAssessments.filter((id) => assessmentList.some((a) => a.id === id)).length} selected</p>
                      )}
                  </SectionCard>

                  {/* Footer */}
                  <div className="flex items-center justify-between pt-2 pb-10">
                    <button type="button" onClick={() => navigate('/app/subscription?tab=0')}
                      className="text-[13px] font-semibold text-[#374151] cursor-pointer px-5 py-[6px] rounded-[8px] border border-[#d1d5db] bg-white hover:border-[#9ca3af] hover:bg-[#f9fafb] transition-all duration-150">
                      Cancel
                    </button>
                    <div className="flex gap-[10px]">
                      <LoadingButton type="submit" loading={submittingDraft} variant="outlined" onClick={() => { publishModeRef.current = 'draft'; }}
                        sx={{ fontSize: '13px', fontWeight: 600, borderRadius: '8px', borderColor: '#d1d5db', color: '#374151', textTransform: 'none', px: '20px' }}>
                        Save as Draft
                      </LoadingButton>
                      {/* <LoadingButton type="submit" loading={submittingPublish} variant="contained" onClick={() => { publishModeRef.current = 'publish'; }}
                        sx={{ fontSize: '13px', fontWeight: 600, borderRadius: '8px', background: '#2563eb', textTransform: 'none', px: '20px', '&:hover': { background: '#1d4ed8' } }}>
                        Publish Plan
                      </LoadingButton> */}
                    </div>
                  </div>
                </Form>
              </>
            );
          }}
        </Formik>
      </div>
      <SnackBar open={snackbar.open} snackbarTitle={snackbar.title} close={() => setSnackbar({ open: false, title: '' })} />
    </Page>
  );
};

export default CreateAssessmentPlan;